import React from "react";
import dayjs from "dayjs";

import {useAppSelector} from "./useStore";
import {bookingInfo} from "../helpers/booking";
import {getAccountMembershipNumber} from "../lib/activeMember";
import {dateTimeFormat} from "../lib/time";
import {selectHasStaffRole} from "../store/slices/userSlice";
import {useGetBookingDeploymentHistoryQuery} from "../store/api/bookingsApi";

const useBookingDeploymentHistory = (bookingID: number) => {
    const isStaff = useAppSelector(state => selectHasStaffRole(state, ['regular']));
    const {data: bookingDeploymentHistory, isFetching: bookingDeploymentHistoryFetching, error: bookingDeploymentHistoryError} = useGetBookingDeploymentHistoryQuery(bookingID);

    let newBookingDeploymentTimeline: object[] = [];
    const size = bookingDeploymentHistory?.length ?? 0;

    if (size > 0 && bookingDeploymentHistory) {
        for (let i = 0; i < size; ++i) {
            let bookingHistoryTitle = null;
            let modifier = null;

            const bookingDeploymentProperties = JSON.parse(bookingDeploymentHistory[i].properties);
            const isCancelled = bookingDeploymentProperties.attributes.state === 'CANCELLED';

            if (i === 0) bookingHistoryTitle = bookingInfo.history.currentBookingInfo;
            else if (i > 0 && i < size - 1) bookingHistoryTitle = bookingInfo.history.bookingChange;
            else if (i === size - 1) bookingHistoryTitle = bookingInfo.history.bookingMade;

            if (bookingDeploymentProperties.is_staff === true) {
                if (isStaff) {
                    modifier = "Staff (" + bookingDeploymentProperties.email + ")";
                } else {
                    modifier = "Staff";
                }
            } else {
                const curAccountMembershipNumber = getAccountMembershipNumber();
                const modifierAccountMembershipNumber = bookingDeploymentProperties.account_membership_number;
                if (isStaff || modifierAccountMembershipNumber === curAccountMembershipNumber) {
                    modifier = modifierAccountMembershipNumber + " " + bookingDeploymentProperties.full_name;
                }
            }

            newBookingDeploymentTimeline.push(
                {
                    key: i,
                    label: (
                        <>
                            <p>{dayjs(bookingDeploymentHistory[i].created_at).tz().format('DD MMM YYYY')}</p>
                            <p>{dayjs(bookingDeploymentHistory[i].created_at).tz().format('h:mm A')}</p>
                        </>
                    ),
                    children: (
                        <>
                            {isCancelled ? <p className="booking-history-card-cancelled-text">Booking cancelled</p> : <p><strong>{bookingHistoryTitle}</strong></p>}
                            <p>{dayjs(bookingDeploymentProperties.attributes.started_at).tz().format(dateTimeFormat)} - {dayjs(bookingDeploymentProperties.attributes.ended_at).tz().format(dateTimeFormat)}</p>
                            <p>{bookingDeploymentProperties.car.year} {bookingDeploymentProperties.car.colour} {bookingDeploymentProperties.car.make} {bookingDeploymentProperties.car.model}</p>
                            <p className="author">{modifier}</p>
                        </>
                    )
                }
            )
        }
    }

    return {
        result: newBookingDeploymentTimeline,
        isLoading: bookingDeploymentHistoryFetching,
        error: bookingDeploymentHistoryError
    }
};

export {useBookingDeploymentHistory};
